import { ContractStatus } from "../../enums/contract-status"
import { DonationType } from "../../enums/donation-type"
import { PaymentMethodType } from "../../enums/payment-method-type"
import { PicklistItem } from "../../types/filters"
import { contractStatusStrings, contractTypeStrings, paymentMethodTypeStrings } from "../../utils/strings/DonationStrings"


export const type_picklist: PicklistItem[] = [
  { id: DonationType.oneOff, label: contractTypeStrings[DonationType.oneOff] },
  { id: DonationType.recurring, label: contractTypeStrings[DonationType.recurring] }
]

export const status_picklist: PicklistItem[] = [
  { id: ContractStatus.draft, label: contractStatusStrings[ContractStatus.draft] },
  { id: ContractStatus.intent, label: contractStatusStrings[ContractStatus.intent] },
  { id: ContractStatus.finalized, label: contractStatusStrings[ContractStatus.finalized] },
  { id: ContractStatus.externallyManaged, label: contractStatusStrings[ContractStatus.externallyManaged] },
  { id: ContractStatus.completed, label: contractStatusStrings[ContractStatus.completed] },
  { id: ContractStatus.canceled, label: contractStatusStrings[ContractStatus.canceled] }
]

export const payment_methods_options: PicklistItem[] = [
  { id: PaymentMethodType.stripeCard, label: paymentMethodTypeStrings[PaymentMethodType.stripeCard] },
  { id: PaymentMethodType.stripeSetupCard, label: paymentMethodTypeStrings[PaymentMethodType.stripeSetupCard] },
  { id: PaymentMethodType.stripePaymentSheet, label: paymentMethodTypeStrings[PaymentMethodType.stripePaymentSheet] },
  { id: PaymentMethodType.stripeSetupPaymentSheet, label: paymentMethodTypeStrings[PaymentMethodType.stripeSetupPaymentSheet] },
  { id: PaymentMethodType.cash, label: paymentMethodTypeStrings[PaymentMethodType.cash] }
]